import type { CSSProperties } from "react";
import styles from "./LoadingSpinner.module.css";
import { Typography } from "@mui/material";

interface LoadingSpinnerProps {
    label?: string;
    size?: number;
}

const DEFAULT_LOADING_LABEL = "Inhalte werden geladen";

export default function LoadingSpinner({ label, size = 120 }: LoadingSpinnerProps) {
    const safeSize = Number.isFinite(size) && size > 0 ? size : 120;
    const style = {
        "--spinner-size": `${safeSize}px`,
    } as CSSProperties;

    return (
        <div
            className={styles.root}
            role="status"
            aria-live="polite"
            aria-label={label ?? DEFAULT_LOADING_LABEL}
            style={style}
        >
            <svg
                className={styles.spinner}
                viewBox="0 0 140 140"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
            >
                <circle className={styles.centerGlow} cx="70" cy="70" r="20" />
                <circle className={styles.orbitRing} cx="70" cy="70" r="30" />
                <circle className={styles.orbitRing} cx="70" cy="70" r="40" />
                <g className={styles.orbitGroup}>
                    <circle className={styles.dot} cx="70" cy="30" r="4" />
                </g>
                <g className={styles.orbitGroupDelayed}>
                    <circle className={styles.dot} cx="70" cy="30" r="4" />
                </g>
                <g className={styles.orbitGroupSlow}>
                    <circle className={styles.dot} cx="70" cy="30" r="4" />
                </g>
            </svg>

            {label ? (
                <Typography className={styles.label} color="primary" variant="subtitle1">{label}</Typography>
            ) : (
                <span className={styles.srOnly}>{DEFAULT_LOADING_LABEL}</span>
            )}
        </div>
    );
}
